import axios from '../utils/api';

const base_url = process.env.REACT_APP_API_URL_ADMIN;

export const getMyPrivileges = () => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'privilege',
      command: 'getMyPrivileges',
    });
    if (response.data?.status !== 200) {
      throw new Error(response.data?.message || 'Failed to load privileges');
    }
    const privileges = response.data.data?.privileges || {};
    const fieldPrivileges = response.data.data?.fieldPrivileges || {};
    dispatch({ type: 'SET_USER_PRIVILEGES', payload: privileges });
    dispatch({ type: 'SET_USER_FIELD_PRIVILEGES', payload: fieldPrivileges });
    return { privileges, fieldPrivileges };
  } catch (error) {
    console.error('getMyPrivileges failed:', error);
    throw error;
  }
};

export const getEditableRoles = async () => {
  const response = await axios.post(`${base_url}`, {
    apiName: 'privilege',
    command: 'getEditableRoles',
  });
  if (response.data?.status !== 200) {
    throw new Error(response.data?.message || 'Failed to load editable roles');
  }
  return response.data.data?.roles || [];
};

export const getRolePrivileges = async ({ targetRole, company_id }) => {
  const response = await axios.post(`${base_url}`, {
    apiName: 'privilege',
    command: 'getRolePrivileges',
    targetRole,
    company_id,
  });
  if (response.data?.status !== 200) {
    throw new Error(response.data?.message || 'Failed to load role privileges');
  }
  return response.data.data;
};

export const getPrivilegeCatalog = async (targetRole) => {
  const response = await axios.post(`${base_url}`, {
    apiName: 'privilege',
    command: 'getCatalog',
    targetRole,
  });
  if (response.data?.status !== 200) {
    throw new Error(response.data?.message || 'Failed to load catalog');
  }
  return response.data.data;
};

export const getCatalogRoles = async () => {
  const response = await axios.post(`${base_url}`, {
    apiName: 'privilege',
    command: 'getCatalogRoles',
  });
  if (response.data?.status !== 200) {
    throw new Error(response.data?.message || 'Failed to load catalog roles');
  }
  return response.data.data?.roles || [];
};

export const getRoleCatalog = async (targetRole) => {
  const response = await axios.post(`${base_url}`, {
    apiName: 'privilege',
    command: 'getRoleCatalog',
    targetRole,
  });
  if (response.data?.status !== 200) {
    throw new Error(response.data?.message || 'Failed to load privilege catalog');
  }
  return response.data.data;
};

export const saveRoleCatalog = async ({ targetRole, options }) => {
  const response = await axios.post(`${base_url}`, {
    apiName: 'privilege',
    command: 'saveRoleCatalog',
    targetRole,
    options,
  });
  if (response.data?.status !== 200) {
    const err = new Error(response.data?.message || 'Failed to save privilege catalog');
    err.status = response.data?.status;
    throw err;
  }
  return response.data;
};

export const saveRolePrivileges = async ({ targetRole, privileges, company_id }) => {
  const response = await axios.post(`${base_url}`, {
    apiName: 'privilege',
    command: 'saveRolePrivileges',
    targetRole,
    privileges,
    company_id,
  });
  if (response.data?.status !== 200) {
    const err = new Error(response.data?.message || 'Failed to save privileges');
    err.status = response.data?.status;
    throw err;
  }
  return response.data;
};

export const getRoleFieldPrivileges = async ({ targetRole, company_id }) => {
  const response = await axios.post(`${base_url}`, {
    apiName: 'privilege',
    command: 'getRoleFieldPrivileges',
    targetRole,
    company_id,
  });
  if (response.data?.status !== 200) {
    throw new Error(response.data?.message || 'Failed to load field privileges');
  }
  return response.data.data;
};

export const saveRoleFieldPrivileges = async ({ targetRole, fields, company_id }) => {
  const response = await axios.post(`${base_url}`, {
    apiName: 'privilege',
    command: 'saveRoleFieldPrivileges',
    targetRole,
    fields,
    company_id,
  });
  if (response.data?.status !== 200) {
    const err = new Error(response.data?.message || 'Failed to save field privileges');
    err.status = response.data?.status;
    throw err;
  }
  return response.data;
};
